import { Avatar, Button, Grid, List, ListItem, ListItemAvatar, ListItemText } from "@mui/material";
import React from "react";
import Blank from "src/icons/Blank";
import { setSelectedCurrency } from "src/store/features/settings.slice";
import { useAppDispatch } from "src/store/store";
import CountryOrCryptoFlag from "../common/CountryOrCryptoFlag";
import { SelectCurrencyStyles } from "../wallets/common/styles/SelectCurrency.styles";
import ModalTransition from "../wallets/Modal/ModalTransition";
import CloseIcon from "@mui/icons-material/Close";

import {
  CloseButton,
  Header,
  HeaderAndSearch,
  SearchBar,
  SearchBarIcon,
  SearchBarWrapper,
  Wrapper,
} from "../common/crypto-selection-modalV2/CryptoSelectionModalV2";
import MagnifyingGlass from "src/icons/MagnifyingGlass";

export type DialogData = {
  clickValue: any;
  img?: string | JSX.Element;
  listPrimary: string;
  listSecondary: string;
};

interface CustomDialogProps {
  // handling opening/closing dialog
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onSearch: (search: string) => void;
  onClick: (icon: string | null, type: string) => void;
  // subtitle of dialog
  subtitle?: string;
  all?: boolean;
  data: DialogData[];
}

const CustomDialog = (props: CustomDialogProps) => {
  const classes = SelectCurrencyStyles();
  const { open, setOpen, onSearch } = props;

  // redux
  const reduxDispatch = useAppDispatch();

  // GLOBAL CONTEXT
  const handleClose = (reason: any) => {
    onSearch(""); // clear user search
    setOpen(false);
  };

  // SEND SELECTED CURRENCY TO CONTEXT
  const handleCurrency = (event: React.MouseEvent, icon: string | null, type: string): void => {
    event.stopPropagation();

    if (props.onClick) {
      props.onClick(icon, type);
      setOpen(false);
      return;
    }
    reduxDispatch(setSelectedCurrency(type));
    setOpen(false);
    return;
  };

  return (
    <Wrapper
      open={open}
      TransitionComponent={ModalTransition}
      onClose={handleClose}
      aria-describedby="deposit-crypto-modal"
      sx={{ "& .MuiDialog-paper": { height: "fit-content" } }}>
      {/* SUBTITLE AND X ICON */}
      <HeaderAndSearch>
        <Header>
          Select currency
          {/* close button */}
          <CloseButton onClick={handleClose}>
            <CloseIcon fontSize="inherit" />
          </CloseButton>
        </Header>

        <SearchBarWrapper>
          <SearchBar
            autoFocus
            placeholder="Search a coin"
            onChange={(e) => onSearch(e.target.value)}
          />
          <SearchBarIcon>
            <MagnifyingGlass />
          </SearchBarIcon>
        </SearchBarWrapper>
      </HeaderAndSearch>

      {/* DROPDOWN CONTENT */}
      <Grid container>
        <Grid item xs>
          <List className={classes.list}>
            {props.all ? (
              <>
                <Button disableRipple fullWidth key={"all"}>
                  <ListItem onClick={(event) => handleCurrency(event, null, "All")}>
                    <ListItemAvatar>
                      <Avatar style={{ backgroundColor: "transparent" }}>
                        <Blank />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={<b>{"ALL"}</b>}
                      secondary={"All Currencies"}
                      sx={{ textTransform: "none" }}
                    />
                  </ListItem>
                </Button>
              </>
            ) : null}
            {props.data.map((el: DialogData, idx: number) => (
              <Button disableRipple fullWidth key={idx}>
                <ListItem
                  onClick={(event) => {
                    let icon = null as string | null;
                    if (typeof el?.img === "string") {
                      icon = el?.img;
                    }
                    handleCurrency(event, icon, el.clickValue);
                  }}>
                  <ListItemAvatar>
                    <Avatar style={{ backgroundColor: "transparent" }}>
                      {typeof el?.img === "string" ? (
                        <CountryOrCryptoFlag name={el?.img} size={40} />
                      ) : (
                        el?.img
                      )}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={<b>{el.listPrimary}</b>}
                    secondary={el.listSecondary}
                    sx={{ textTransform: "none" }}
                  />
                </ListItem>
              </Button>
            ))}
          </List>
        </Grid>
      </Grid>
    </Wrapper>
  );
};

export default CustomDialog;
